module.exports = __webpack_public_path__ + "static/media/install1.5bf5ef85.png";